<form novalidate #propertyInformationSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <tg-row
      class="property-information-section__container"
      >
      <tg-col md="9" sm="12">
        <tg-row>
          <tg-col sm="12">
            <h1 class="property-information-section__section-heading">
              Property information
            </h1>
          </tg-col>
        </tg-row>
        <tg-row>
          <tg-col lg="2" md="3" sm="6">
            <tg-input-container
              class="hide-optional-label"
              label="Street #"
              showRemainingCharacters="false"
              >
              <input
                tgTextInput
                name="streetNo"
                type="text"
                (blur)="publish()"
              [(ngModel)]="
                                draftData.propertyInformation.streetNumber
                            "
                size="large"
              [validation]="
                                validation.propertyInformation.streetNumber
                                    | toValidator
                            "
                [disabled]="isDisabledInput"
                />
              </tg-input-container>
            </tg-col>
            <tg-col lg="2" md="3" sm="6">
              <tg-input-container
                class="hide-optional-label"
                label="Unit / Flat"
                showRemainingCharacters="false"
                >
                <input
                  tgTextInput
                  name="unit"
                  type="text"
                  (blur)="publish()"
                  [(ngModel)]="draftData.propertyInformation.unitFlat"
              [validation]="
                                validation.propertyInformation.unitFlat
                                    | toValidator
                            "
                  [disabled]="isDisabledInput"
                  />
                </tg-input-container>
              </tg-col>
              <tg-col lg="8" md="6" sm="12">
                <tg-input-container
                  class="hide-optional-label"
                  label="Street name"
                  showRemainingCharacters="false"
                  >
                  <input
                    tgTextInput
                    name="streetName"
                    type="text"
                    (blur)="publish()"
              [(ngModel)]="
                                draftData.propertyInformation.streetName
                            "
              [validation]="
                                validation.propertyInformation.streetName
                                    | toValidator
                            "
                    [disabled]="isDisabledInput"
                    />
                  </tg-input-container>
                </tg-col>
              </tg-row>
              <tg-row>
                <tg-col sm="12">
                  <p class="p-secondary-copy">
                    Enter the full address so we can display a map on your listing.
                  </p>
                </tg-col>
              </tg-row>
              @if (hasErrorInStreetNumberAndName) {
                <tg-row>
                  <tg-col>
                    <p class="property-information-section__validate-fail">
                      {{invalidStreetNameErrorMessage}}
                    </p>
                  </tg-col>
                </tg-row>
              }
              @if (hasErrorInStreetNumberOrNameAndUnitFlat) {
                <tg-row>
                  <tg-col>
                    <p class="property-information-section__validate-fail">
                      {{ invalidStreetNameOrNumberErrorMessage }}
                    </p>
                  </tg-col>
                </tg-row>
              }
              <tg-row
                class="property-information-section__property-dropdown-selections-row-medium-spacing"
                >
                <tg-col md="4" sm="12">
                  <tg-select-container class="hide-optional-label" label="Region">
                    <select
                      tgSelect
                      name="region"
                      (change)="regionChange()"
                      [(ngModel)]="draftData.propertyInformation.regionId"
              [validation]="
                                validation.propertyInformation.regionId
                                    | toValidator
                            "
                      [disabled]="isDisabledInput"
                      >
                      @for (region of metadata.regions; track region) {
                        <option
                          [ngValue]="region.regionId"
                          >
                          {{ region.name }}
                        </option>
                      }
                    </select>
                  </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                  <tg-select-container
                    class="hide-optional-label"
                    label="District"
            [class.o-select--is-disabled]="
                            !draftData.propertyInformation.regionId || isDisabledInput
                        "
                    >
                    <select
                      tgSelect
                      name="district"
                      (change)="districtChange()"
              [(ngModel)]="
                                draftData.propertyInformation.districtId
                            "
                      [disabled]="!draftData.propertyInformation.regionId || isDisabledInput"
              [validation]="
                                validation.propertyInformation.districtId
                                    | toValidator
                            "
                      >
                      <option [ngValue]="null">
                        {{
                        !draftData.propertyInformation.regionId
                        ? 'Choose a region first'
                        : 'Choose a district'
                        }}
                      </option>
                      @for (
                        district of selectedRegion?.districts
                        ; track
                        district) {
                        <option
                          [ngValue]="district.districtId"
                          >
                          {{ district.name }}
                        </option>
                      }
                    </select>
                  </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                  <tg-select-container
                    class="hide-optional-label"
                    label="Suburb"
            [class.o-select--is-disabled]="
                            !draftData.propertyInformation.districtId || isDisabledInput
                        "
                    >
                    <select
                      tgSelect
                      name="suburb"
                      (change)="publish()"
                      [(ngModel)]="draftData.propertyInformation.suburbId"
              [disabled]="
                                !draftData.propertyInformation.districtId || isDisabledInput
                            "
              [validation]="
                                validation.propertyInformation.suburbId
                                    | toValidator
                            "
                      >
                      <option [ngValue]="null">
                        {{
                        !draftData.propertyInformation.regionId
                        ? 'Choose a region first'
                        : 'Choose a suburb'
                        }}
                      </option>
                      @for (suburb of selectedDistrict?.suburbs; track suburb) {
                        <option
                          [ngValue]="suburb.suburbId"
                          >
                          {{ suburb.name }}
                        </option>
                      }
                    </select>
                  </tg-select-container>
                </tg-col>
              </tg-row>
              <tg-row>
                <tg-col md="4" sm="12">
                  <tg-input-container label="Land area (m²)">
                    <input
                      wholeNumber
                      tgTextInput
                      name="landArea"
                      (blur)="publish()"
                      [(ngModel)]="draftData.propertyInformation.landArea"
              [validation]="
                                validation.propertyInformation.landArea
                                    | toValidator
                            "
                      [disabled]="isDisabledInput"
                      /> </tg-input-container
                    ></tg-col>
                  </tg-row>
                </tg-col>
                @if (isDisabledInput) {
                  <property-information-notice-with-display-fields displayFields="address and land area"
                  ></property-information-notice-with-display-fields>
                }
              </tg-row>
            }
          </form>
